<template>
  <!-- 一级菜单   && item.level == 1-->
  <el-submenu v-if="item.children" :index="item.title" :key="item.title" v-show="!item.hidden">
    <template #title>
      <div class="icon"></div>
      <span class="t1">{{ item.title }}</span>
    </template>
    <div v-for="subItem in item.children" :key="subItem.title">
      <SideBarItem :item="subItem" />
    </div>
  </el-submenu>
  <!-- 二级菜单 -->
  <el-menu-item v-else @click="menuClick(item)" :key="item.component" :index="item.component" v-show="!item.hidden">
    <div class="circle-dot"></div>
    <span class="child-t1">{{ item.title }}</span>
  </el-menu-item>
</template>
<script>
export default {
  name: 'SideBarItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  methods: {
    menuClick(item) {
      this.$router.push({path:this.$route.fullPath,query:{menu:item.component}})
    }
  }
}
</script>
<style lang="less">
#app2 .menu-level2 {
  position: relative;
  .arrow {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid #969fbc;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }
  &.is-active {
    .arrow {
      border-left: 5px solid var(--theme-color);
    }
  }
  &:hover {
    .menu-level3 {
      display: block !important;
    }
  }
}
#app2 .menu-level3 {
  display: none;
  position: absolute;
  right: -190px;
  top: 0;
  z-index: 1000;
  .menu-wrap {
    margin-left: 20px;
    width: 190px;
    background: #f5f6fa;
    box-shadow: 0px 2px 10px 0px rgba(201, 208, 228, 0.58);
    border-radius: 4px;
    padding: 20px 0;
  }
  li {
    font-size: 14px;
    color: #333;
    span {
      display: inline-block;
      margin-left: 4px;
      height: 26px;
      line-height: 26px;
      width: 100%;
      border-radius: 3px;
      padding: 0 0 0 32px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  li:hover,
  li.active {
    color: var(--theme-color);
    background: linear-gradient(270deg, rgba(214, 226, 255, 0) 0%, rgba(193, 205, 237, 0.43) 100%);
  }
}
</style>

<style lang="less" scoped>
.el-submenu {
  position: relative;
  .icon {
    width: 23px;
    height: 20px;
    background-image: url('~_img/app-left/menu.png');
    background-size: 100% 100%;
    margin-right: 4px;
    position: absolute;
    left: 30px;
    top: 50%;
    transform: translateY(-50%);
  }
  .circle-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #edeef3;
    box-shadow: 0px 0px 1px 0px #ffffff;
    margin-right: 10px;
    border-radius: 50%;
    position: relative;
    &::after {
      content: '';
      width: 5px;
      height: 5px;
      background: #949dbc;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
    }
  }
  .t1 {
    width: 180px;
    margin-left: 28px;
  }
  .tt1 {
    margin: 0;
  }
  .child-t1 {
    width: 180px;
  }
}
</style>

<style lang="less">
:root{
  --theme-color:#496DDD;
  --theme-color-rgb: 69, 107, 209;
}
#app2 {
  .el-submenu__title {
    font-size: 14px;
    padding-left: 30px !important;
    height: 48px !important;
    line-height: 48px !important;
  }
  .el-menu-item {
    font-size: 14px;
    color: #333;
    white-space: normal;
    height: 40px !important;
    line-height: 40px !important;
    padding: 0 10px 0 50px !important;
    // 悬浮状态
    &:hover {
      box-shadow: 0px 2px 10px 0px rgba(201, 208, 228, 0.58);
      border-radius: 4px;
      color: var(--theme-color) !important;
      background: #fff !important;
      .arrow {
        display: block !important;
      }
      .circle-dot {
        border: 1px solid rgba(var(--theme-color-rgb), 0.7);
        // box-shadow: 0px 0px 1px 0px #ffffff, inset 0px 0px 2px 0px rgba(26, 69, 184, 0.4);
        &::after {
          background: var(--theme-color);
        }
      }
    }
  }

  // 主菜单被点击状态
  .el-submenu.is-active {
    font-weight: bold;
    .el-submenu__title {
      color: var(--theme-color) !important;
      font-size: 16px;
    }
    .icon {
      background: url(~_img/layout/slide_icon_act.png) !important;
      background-size: 100% 100% !important;
    }
    .el-icon-arrow-down {
      &::before {
        border-top: 5px solid var(--theme-color);
      }
    }
  }
  .el-menu--inline {
    font-weight: normal;
    background: transparent !important;
    // padding: 0 10px !important;
    // 子菜单点击状态
    .is-active {
      font-weight: bold;
      background: #ffffff !important;
      box-shadow: 0px 2px 10px 0px rgba(201, 208, 228, 0.58);
      border-radius: 4px;
      color: var(--theme-color) !important;
      .circle-dot {
        border: 1px solid rgba(var(--theme-color-rgb), 0.7);
        // box-shadow: 0px 0px 1px 0px #ffffff, inset 0px 0px 2px 0px rgba(var(--theme-color-rgb),.4);
        &::after {
          background: var(--theme-color);
        }
      }
    }
  }
  .el-icon-arrow-down {
    right: 28px !important;
    margin-top: 2px !important;
    &::before {
      content: '' !important;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #969fbc;
    }
  }

  // 收缩之后
  .el-menu--collapse {
    .t1 {
      display: none;
    }
    .el-submenu__icon-arrow {
      display: none !important;
    }
  }
  // 一级菜单
  .first-level-menu {
    display: flex;
    align-items: center;
    padding: 0;
    .icon {
      width: 23px;
      height: 20px;
      background-image: url('~_img/app-left/menu.png');
      background-size: 100% 100%;
      margin-right: 4px;
      position: absolute;
      left: 30px;
      top: 50%;
      transform: translateY(-50%);
    }
    .t1 {
      padding-left: 8px;
    }
    &.is-active {
      .t1 {
        color: var(--theme-color);
        font-weight: bold;
        font-size: 16px;
      }
      .icon {
        background: url(~_img/layout/slide_icon_act.png) !important;
        background-size: 100% 100% !important;
      }
    }
  }
}
</style>
